import type { FileList } from "../../../parts/filelist/filelist"

type QuotationOverviewState = {
  activeFilePopup: string
}

type QuotationStatus = "Open" | "Closed" | "Canceled"

type QuotationDetailState = {
  quotations: { [key: string]: QuotationDetail }
}

type QuotationDetail = {
  cardCode: string
  cardName: string
  docDate: string
  refNum: string
  status: QuotationStatus
  attachments: FileList
}

let quotationOverview: QuotationOverviewState = {
  activeFilePopup: "",
}
let quotationDetail: QuotationDetailState

export let DATQuotation = { quotationOverview, quotationDetail }
